
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import Cocktails from './cocktails';
import EventsScreen from './events';
import CategoriesScreen from './categories';
import Alcoholic from './alcoholic';
import ListProducts from './ListProducts';
import { getImage, getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';


function Index({dishs2, setShowListProduct, setShowHappy}) { 

    const {i18n} = useTranslation();
    const [showCategories, setshowCategories] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const [showListProduct, setShowListProduct2] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [Beverages, setBeverages] = useState(false);
    const [CatToday, setCatToday] = useState(false);
    const { change, getInitData } = useRefresh();
    const [menuToday, setmenuToday] = useState(false);
    const [menus, setMenus] = useState([]);
      const [image, setImage] = useState(false);

    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);

    useEffect(() => {
        menus.map((item) => {
            if (item.id === 925) {
                setBeverages(item);
            }
            if (item.id === 983) {
                setCatToday(item);
            }
        });
    }, [menus]);


    useEffect(() => {
        if (CatToday) {
            setmenuToday(CatToday.menus[0])
        }
    }, [CatToday]);


    const fetchImage = async (id) => {
          const imageBlob = await getImage(id);
          if (imageBlob) {
              const imageURL = URL.createObjectURL(imageBlob.data.blob);
              return imageURL;
          }
          return null;
      };
  
    

       
    useEffect(() => {
      //  setIsImageLoading(true);
          fetchImage(`menu-image-h-${menuToday.id}`).then((url) => {
              if (url) {
                  setImage(url);
                 // setIsImageLoading(false); 
              }
          });
      }, [menuToday]);

    
    console.log({menuToday})

   

    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent goCategories={() => {
                setShowListProduct2(true)
                setdishs(Beverages)
        }}  showBack={true} showCocktails={ setShowCocktails} showEvents={ setShowEvents} setShowListProduct={setShowListProduct} goHome={setShowHappy} >
                <div style={{padding: '0 20px', height: 780, overflowY: 'auto'}}>
                    

                    
                     <div style={{display: 'flex', justifyContent: 'center', marginBottom: 1, marginTop: 1}}>
                        <img
                            src={image}
                            onContextMenu={(e) => e.preventDefault()}
                            style={{width: '100%', height: 800, objectFit: 'contain', pointerEvents: 'none'}}
                        />
                        
                    </div>


                   

                </div>

                {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct2}
                />}

                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showCocktails && <Cocktails setShowHappy={setShowCocktails} />}
                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
            </LayoutContent>
        </div>
    );
}
export default Index;